export default __webpack_public_path__ + "static/media/10-min.cd6fbf18.jpg";